import PropTypes from 'prop-types';
import React from 'react';
import { PanelGroup, Panel } from 'react-bootstrap';
import SpecDescription from './SpecDescription';
import { trackEvent, toggleSpecCategoryEvent } from '../utils/analytics';

import '../global-sass/main.scss';

export default class SpecCategory extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isExpanded: false
		};
		this.toggleExpand = this.toggleExpand.bind(this);
	}

	toggleExpand() {
		const isExpanded = !this.state.isExpanded;
		const { specCategory, widgetInfo } = this.props;
		const { windowId, widgetName } = widgetInfo;
		this.setState({
			isExpanded
		});
		trackEvent(
			toggleSpecCategoryEvent(
				widgetName,
				windowId,
				isExpanded,
				specCategory
			)
		);
	}

	render() {
		const {
			specCategory,
			specIds,
			specification,
			prefs,
			prefs: {
				widgetHeading,
				toggleCollapse,
				panelHeadingWeight,
				panelHeadingCase
			}
		} = this.props;
		const icon = this.state.isExpanded ? 'collapse' : 'expand';
		const panelHeader = (
			<h4>
				<div className={`${panelHeadingWeight} ${panelHeadingCase}`}>
					<i
						className={`ddc-icon icon-style-collapse ddc-icon-${icon} d-inline mr-3`}
					/>
					{specCategory}
				</div>
			</h4>
		);

		let panelGroupClass = 'spec-category m-0 mb-5 mb-sm-6';

		if (widgetHeading && toggleCollapse === 'true') {
			panelGroupClass = `${panelGroupClass} mx-5`;
		}

		// Feature checking to see if Panel.Heading (Added in react-bootstrap v0.32.0) is present.
		// if not, render the markup compatible with the older version
		// TODO: Delete this once cms-web has been updated with the new version of react-bootstrap
		if (!Panel.Heading) {
			return (
				<PanelGroup className={panelGroupClass.trim()}>
					<Panel
						className="border-0"
						collapsible
						header={panelHeader}
						onSelect={this.toggleExpand}
					>
						<SpecDescription
							prefs={prefs}
							specIds={specIds}
							specification={specification}
						/>
					</Panel>
				</PanelGroup>
			);
		}
		return (
			<PanelGroup className={panelGroupClass.trim()}>
				<Panel className="border-0" onToggle={this.toggleExpand}>
					<Panel.Heading>
						<Panel.Title toggle>{panelHeader}</Panel.Title>
					</Panel.Heading>
					<Panel.Collapse>
						<Panel.Body>
							<SpecDescription
								prefs={prefs}
								specIds={specIds}
								specification={specification}
							/>
						</Panel.Body>
					</Panel.Collapse>
				</Panel>
			</PanelGroup>
		);
	}
}

SpecCategory.propTypes = {
	prefs: PropTypes.shape({
		widgetHeading: PropTypes.string,
		toggleCollapse: PropTypes.string,
		panelHeadingWeight: PropTypes.string,
		panelHeadingCase: PropTypes.string
	}),
	specCategory: PropTypes.string.isRequired,
	specIds: PropTypes.arrayOf(PropTypes.number).isRequired,
	specification: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number.isRequired,
			spec: PropTypes.object.isRequired
		})
	).isRequired,
	widgetInfo: PropTypes.shape({
		windowId: PropTypes.string.isRequired,
		widgetName: PropTypes.string.isRequired
	}).isRequired
};

SpecCategory.defaultProps = {
	prefs: {
		panelHeadingCase: 'text-capitalize',
		panelHeadingWeight: 'font-weight-bold',
		toggleCollapse: '',
		widgetHeading: ''
	}
};



// WEBPACK FOOTER //
// ./src/components/SpecCategory.jsx